export default __webpack_public_path__ + "9ebab925013447f7317b5545c3b9678a.png";